import { Group, Paper, Text } from "@mantine/core";
import { numericFormatter } from "react-number-format";
import type { TooltipPayload } from "recharts";
import { getDefaultNumericFormatterProps } from "../../../utils/getDefaultNumericFormatterProps";

interface MantineLineChartTooltipProps {
  seriesLabels: Record<string, string>;
  title: string;
  payload: TooltipPayload;
}

/*  Mantine doesn't allow changes to the recharts tooltip: https://mantine.dev/charts/line-chart/#custom-tooltip */
function MantineLineChartTooltip({
  seriesLabels,
  title,
  payload
}: MantineLineChartTooltipProps) {
  if (!payload) return null;

  return (
    <Paper
      className="MantineLineChart ChartTooltip"
      px="md"
      py="sm"
      shadow="md"
      withBorder
    >
      <Text fw={500} mb={5}>
        {title}
      </Text>
      {Array.isArray(payload) &&
        payload.slice(0, 10).map((item) => (
          <Group justify="space-between" key={item.name}>
            <Group gap="sm">
              <div className="dot" style={{ backgroundColor: item.color }} />
              <Text fz="sm">{seriesLabels[item.name] || "Unbekannt"}</Text>
            </Group>
            <Text fz="sm">
              {numericFormatter(
                item.value.toString(),
                getDefaultNumericFormatterProps()
              )}
            </Text>
          </Group>
        ))}
      {payload.length > 10 && "..."}
    </Paper>
  );
}

export { MantineLineChartTooltip };
